import { render, staticRenderFns } from "./atlasPage.vue?vue&type=template&id=68877458&scoped=true&"
import script from "./atlasPage.vue?vue&type=script&lang=js&"
export * from "./atlasPage.vue?vue&type=script&lang=js&"
import style0 from "./atlasPage.vue?vue&type=style&index=0&id=68877458&prod&lang=scss&scoped=true&"
import style1 from "./atlasPage.vue?vue&type=style&index=1&id=68877458&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68877458",
  null
  
)

export default component.exports